import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/styles/global.css';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import '@/assets/icon/iconfont.css'
import LoadingButton from '@/components/LoadingButton.vue'
import BookItem from '@/components/BookItem.vue'
import BigBookItem from '@/components/BigBookItem.vue'
import BookShelf from '@/components/BookShelf.vue'

Vue.component('LoadingButton', LoadingButton)
Vue.component('BookItem', BookItem)
Vue.component('BigBookItem', BigBookItem)
Vue.component('BookShelf', BookShelf)


Vue.use(ElementUI)


Vue.use(Antd);
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
    // created() {
    //     // 在 Vue 实例创建时检查本地存储中是否有用户身份验证信息
    //     const token = localStorage.getItem('Authorization');
    //     if (token) {
    //         // 如果有身份验证信息，将其设置到 Vuex store 中
    //         this.$store.commit('setToken', token);
    //     }
    // },
}).$mount('#app')